module.exports = __webpack_public_path__ + "img/DisconnectWatch.41f3f092.svg";